import "./BillResult.scss";

export interface BillResultProps {
    single?: {
        title: string;
        totalCost: string;
        disclaimer: string;
    };
    multi?: {
        disclaimer: string;
        entries: BillResultEntry[];
    }
}

export interface BillResultEntry {
    totalCost: string;
    type: string;
    priceInfo: string;
}

const BillResult = (props: BillResultProps) => {
    function renderMultiEntries(entries: BillResultEntry[]): any {
        const elems: any[] = [];
        for (const entry of entries) {
            elems.push(
                <div className="BillResultEntry">
                    <span className="TotalCost">{entry.totalCost}</span>
                    <div className="Info">
                        <b>{entry.type}</b>
                        <span>{entry.priceInfo}</span>
                    </div>
                </div>
            )
        }
        return elems;
    }

    function sanitizeDisclaimer(disclaimer?: string): string {
        if (!disclaimer || disclaimer === 'null' || disclaimer === 'undefined') {
            return '';
        }
        return disclaimer;
    }

    if (props.single) {
        return (
            <div className="BillResultSingle">
                <div className="CostInfo">
                    <div>{props.single.title}</div>
                    <div>{props.single.totalCost}</div>
                </div>
                {sanitizeDisclaimer(props.single.disclaimer) && (
                    <div className="Disclaimer">{props.single.disclaimer}</div>
                )}
            </div>
        )
    } else {
        return (
            <div className="BillResultMulti">
                {sanitizeDisclaimer(props.multi?.disclaimer) && (
                    <div className="Disclaimer">{props.multi?.disclaimer}</div>
                )}
                <div className="BillResultEntries">
                    {renderMultiEntries(props.multi?.entries as any)}
                </div>
            </div>
        )
    }
}

export default BillResult;
